export default "__VITE_ASSET__C3gQ$wM2__"